// These default breakpoints are in ems, px equivalents are when font size is at default 16px
const DEFAULT_BREAKPOINTS = {
  xs: 0,
  // 0px
  sm: 30,
  // 480px
  md: 48,
  // 768px
  lg: 64,
  // 1024px
  xl: 90 // 1440px
};
const POPPER_PLACEMENTS = ['top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end'];

/* Popper offset documentation: https://popper.js.org/docs/v2/modifiers/offset/
 * Reminder that the 'placement' prop influences the direction of skidding and distance
 */
const SUBMENU_POPPER_OFFSET = [0, 0];
const FLYOUT_POPPER_OFFSET = [0, 6];
const TOOLTIP_POPPER_OFFSET = [0, 12]; // Distance of 12 is 6px for the half of the arrow's hypotenuse + 6px for the actual distance

const FOCUS_RING_WIDTH = 4;

export { DEFAULT_BREAKPOINTS, FLYOUT_POPPER_OFFSET, FOCUS_RING_WIDTH, POPPER_PLACEMENTS, SUBMENU_POPPER_OFFSET, TOOLTIP_POPPER_OFFSET };
